<template>
  <form @submit.prevent="submit">
    <base-modal small target="investorAllocationModal" title="Allocate Shares">
      <template v-if="completed">
        <p class="text-center">
          Shares have successfully been allocated.
        </p>
      </template>
      <template v-else-if="pending">
        <base-loader>Allocating...</base-loader>
      </template>
      <template v-else>
        <base-field label="Investor">
          <base-select
            v-model="user"
            store="core.users.investors"
            store-action="core/users/investors"
            store-text="email"
            placeholder="investor"
            required />
        </base-field>
        <base-field label="Funding Round">
          <base-select v-model="funding" placeholder="funding round" required>
            <template v-for="(round, key) in investment.rounds">
              <option :key="key" :value="round._id">
                {{ round.name }}
              </option>
            </template>
          </base-select>
        </base-field>
        <base-field addon-left-icon="pound-sign" label="Amount">
          <base-input v-model="amount" numeric placeholder="amount" required />
        </base-field>
        <base-field addon-left-icon="pound-sign" label="Re-financed Amount">
          <base-input v-model="refinanced" numeric placeholder="amount" required />
        </base-field>
        <base-checkbox v-model="backdate" class="mb-3">
          Backdate this allocation?
        </base-checkbox>
        <base-field v-if="backdate" addon-right-icon="calendar-alt" label="Backdated Date" mandatory>
          <base-input v-model="date" datepicker placeholder="backdated date" required />
        </base-field>
        <base-checkbox v-model="statement" class="mb-3">
          Apply to statement
        </base-checkbox>
        <div class="bg-light text-center">
          <strong>{{ $formatting.toCurrency(investment.costPerShare) }}</strong> per share
        </div>
      </template>
      <template v-if="!pending" v-slot:footer>
        <template v-if="completed">
          <base-button @click="close">Close</base-button>
        </template>
        <template v-else>
          <base-button @click="close">Cancel</base-button>
          <base-button secondary submit>Allocate</base-button>
        </template>
      </template>
    </base-modal>
  </form>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import EventBus from '../libs/EventBus'

export default {
  name: 'InvestorAllocation',

  data: () => ({
    amount: '',
    backdate: false,
    completed: false,
    date: '',
    funding: null,
    refinanced: '',
    statement: true,
    user: ''
  }),

  computed: {
    ...mapState({
      investment: store => store.core.investments.entity,
      pending: store => store.core.shares.isAllocatePending
    })
  },

  methods: {
    close () {
      this.$emit('close')
      this.$modal.close('#investorAllocationModal')

      this.amount = ''
      this.completed = false
      this.refinanced = ''
      this.statement = true
      this.user = ''
    },

    submit () {
      this.allocate({
        amount: this.amount,
        backdate: this.backdate,
        date: this.date,
        funding: this.funding,
        investment: this.investment._id,
        refinanced: this.refinanced,
        statement: this.statement,
        user: this.user
      })
        .then(() => {
          this.completed = true

          EventBus.$emit('reload-PaginatedList-shares')
        })
        .catch(err => this.$flash.failure(err))
    },

    ...mapActions({
      allocate: 'core/shares/allocate'
    })
  }
}
</script>
